import { useState } from "react";

/** Copyable 6-char join code pill. The code is contribute-only (never gates
 *  viewing — that is the shareToken). Copy = the MVP contribution handoff
 *  (paste in-app after install); deep-link auto-apply is a fast-follow. */
export function JoinCode({ code }: { code: string }) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1600);
    } catch {
      // Clipboard blocked (insecure context / permissions) — select fallback.
      setCopied(false);
    }
  }

  return (
    <button
      type="button"
      className="join-code"
      onClick={copy}
      aria-label={`Join code ${code.split("").join(" ")}. Tap to copy.`}
    >
      <span className="label">{copied ? "Copied" : "Join code"}</span>
      <span className="join-code__value">{code}</span>
    </button>
  );
}
